var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgModeIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 2v-.25A.752.752 0 006.25 1h-2.5a.752.752 0 00-.75.75V2H0v2h3v.25c0 .412.337.75.75.75h2.5c.412 0 .75-.338.75-.75V4h9V2H7zM4 4V2h2v2H4zm9 2.75a.753.753 0 00-.75-.75h-2.5a.753.753 0 00-.75.75V7H0v2h9v.25c0 .412.338.75.75.75h2.5c.412 0 .75-.338.75-.75V9h3V7h-3v-.25zM10 9V7h2v2h-2zm-3 2.75a.753.753 0 00-.75-.75h-2.5a.752.752 0 00-.75.75V12H0v2h3v.25c0 .412.337.75.75.75h2.5c.412 0 .75-.338.75-.75V14h9v-2H7v-.25zM4 14v-2h2v2H4z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgModeIcon);
export default __webpack_public_path__ + "static/media/mode-icon.6e65d1b373cdabed447fb3d3870cf1d0.svg";
export { ForwardRef as ReactComponent };